import { Empty } from 'antd';

export const EmptyPlaceholder = () => {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <Empty />
    </div>
  );
};
